import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';
import { Suggestions } from './suggestions';
import { TNoResultSuggestion } from '../_component_types/no_result_suggestion/no_result_suggestion';

function NoResults({ suggestions, onImproveClick, onRemoveClick }) {
    return (
        <div className="no-results">
            <Translation
                translationKey="catalog-items-no-results-headline"
                tagName="h2"
                className="no-results__headline"
            />
            <Translation
                translationKey="catalog-items-no-results-text"
                tagName="p"
                className="no-results__text"
            />
            <Suggestions
                suggestions={suggestions}
                onImproveClick={onImproveClick}
                onRemoveClick={onRemoveClick}
            />
        </div>
    );
}

NoResults.propTypes = {
    suggestions: PropTypes.arrayOf(TNoResultSuggestion).isRequired,
    onImproveClick: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired,
};

export { NoResults };
